import * as API from "./api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { infoFunction } from "../../../../Components/Alert/Alert";

// ledger report
export const getProductLedgerReport = createAsyncThunk(
  "productLedger/getProductLedgerReport",
  async (params, { rejectWithValue }) => {
    try {
      const { rowsPerPage, search, sortOrder, pageNo, product, branch,  } = params;
      const { data } = await API.getProductLedgerReportData({
        rowsPerPage: rowsPerPage,
        search,
        sortOrder,
        pageNo,
        branch: branch ? branch?.id : "",
        product: product ? product?.id : "",
      });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get previous  page
export const getProductLedgerPrevious = createAsyncThunk(
  "productLedger/getProductLedgerPrevious",
  async (previous, { rejectWithValue }) => {
    try {
      const { data } = await API.getProductLedgerPrevious(previous);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
// get next  page
export const getProductLedgerNext = createAsyncThunk(
  "productLedger/getProductLedgerNext",
  async (next, { rejectWithValue }) => {
    try {
      const { data } = await API.getProductLedgerNext(next);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//get particular page
export const getProductLedgerParticularPage = createAsyncThunk(
  "productLedger/getProductLedgerParticularPage",
  async (params, { rejectWithValue }) => {
    try {
      const { rowsPerPage, search, number, product, branch,  } = params;
      const { data } = await API.getProductLedgerParticularPage({
        number,
        rowsPerPage,
        search,
        branch: branch ? branch?.id : "",
        product: product ? product?.id : "",
      });
      if (!data?.data.length > 0) {
        infoFunction("Data Not found");
      } else {
        return data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
